module.exports = __webpack_public_path__ + "Assets/AOK_Favicon_Lightmode.ico";